<fui-edit-fascia class="main" (clicked$)="click()" [disabled]="disabled" [focussed]="focussed" (focussed$)="focus()"
                 [hovered]="hovered" [dragging]="dragging"
                 (dragenter)="handleDragEnter($event)" (dragleave)="handleDragLeave($event)"
                 (drop)="fileDropped($event)">
    <fui-fixtures class="label" (click)="$event.stopPropagation()">
        <fui-fixture>
            <fui-input-label [disabled]="disabled" [focussed]="focussed" [hovered]="hovered"
                             [title]="label" [valued]="valued"></fui-input-label>
        </fui-fixture>
    </fui-fixtures>
    <fui-fixtures (click)="$event.stopPropagation()">
        <fui-spanning-fixture class="content" [tabindex]="tabindex"
                              (blur)="onBlur($event)" (focus)="onFocus($event)">
            <fui-image *ngIf="showImage" class="content-image" (click)="click($event)"
                       [imageBase64]="value || placeholderImage" [imageOpacity]="imageOpacity"
                       [allowSvg]="allowSvg" [canvasType]="canvasType">
            </fui-image>
            <div *ngIf="(value || !showImage) && showOpacitySlider" class="content-opacity">
                <kendo-slider class="content-opacity-slider"
                              [(ngModel)]="imageOpacity" [min]="0.0" [max]="1.0" [smallStep]="0.01"
                              [tickPlacement]="'after'">
                </kendo-slider>
                <div class="content-opacity-label">{{'fui.image-control.label.opacity' | translate}}: {{opacityPercent}}%</div>
            </div>
            <fui-input-dom *ngIf="showImage">
                <input #input class="content-input" [disabled]="disabled" type="file" [attr.accept]="validFileTypes"
                       (change)="fileSelected($event)">
            </fui-input-dom>
        </fui-spanning-fixture>
        <fui-action-fixture *ngIf="showImage" class="actions">
            <fui-action class="actions-action" (click)="click($event)">
                <fui-icon [height]="20" [icon]="'lookup'" [width]="20"></fui-icon>
            </fui-action>
            <div class="actions-action wrapper">
                <div class="background-control" (click)="cycleCanvas()"
                     [ngClass]="{
                         'checkered': canvasType === CanvasType.CHECKERED,
                         'dark': canvasType === CanvasType.DARK,
                         'light': canvasType === CanvasType.LIGHT
                     }"></div>
            </div>
            <fui-action class="actions-action" (click)="clear($event)" [disabled]="!value">
                <fui-icon [height]="20" [width]="20" [icon]="'delete'"></fui-icon>
            </fui-action>
        </fui-action-fixture>
        <fui-fixture *ngIf="validateable">
            <fui-validations [control]="control" [focussed]="focussed"></fui-validations>
        </fui-fixture>
    </fui-fixtures>
</fui-edit-fascia>
